module.exports = __webpack_public_path__ + "img/logo-kefuri.ab68b46a.png";